"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Banker = _interopRequireDefault(require("./Banker"));

var _Gambler = _interopRequireDefault(require("./Gambler"));

var _CommandQueue = _interopRequireDefault(require("./CommandQueue"));

var _SetFirstAttackerCommand = _interopRequireDefault(require("./commands/SetFirstAttackerCommand"));

var _DealCardsCommand = _interopRequireDefault(require("./commands/DealCardsCommand"));

var _DiscardCardCommand = _interopRequireDefault(require("./commands/DiscardCardCommand"));

var _AttackCommand = _interopRequireDefault(require("./commands/AttackCommand"));

var _DefendCommand = _interopRequireDefault(require("./commands/DefendCommand"));

var _TakeOpenedCardsCommand = _interopRequireDefault(require("./commands/TakeOpenedCardsCommand"));

var _StartNewRoundCommand = _interopRequireDefault(require("./commands/StartNewRoundCommand"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GameStore = /*#__PURE__*/function () {
  function GameStore(_ref) {
    var _this = this;

    var setData = _ref.setData;

    _classCallCheck(this, GameStore);

    _defineProperty(this, "fool", null);

    _defineProperty(this, "banker", null);

    _defineProperty(this, "gamblers", []);

    _defineProperty(this, "queue", null);

    _defineProperty(this, "setData", null);

    _defineProperty(this, "userAction", null);

    _defineProperty(this, "run", function () {
      var res = _this.queue.execute();

      if (res) {
        switch (res.type) {
          case _constants.COMMANDS.SET_FIRST_ATTACKER:
            {
              _this.banker.setAttacker(res.attacker);

              _this.updateAttacker();

              _this.updateSilence(false);

              if (_this.banker.isAttackerRobot) {
                _this.queue.enqueue(new _AttackCommand["default"]({
                  store: _this
                }));
              }

              break;
            }

          case _constants.COMMANDS.DEAL_CARD:
            {
              _this.updateSilence(false);

              break;
            }

          case _constants.COMMANDS.DISCARD_CARD:
            {
              if (res.success) {
                _this.openedCards.push(res.card);

                _this.updateOpenedCards();

                _this.updateGamblerHand(res.gambler);

                if (_this.banker.isGameFinished) {
                  if (res.gambler.isHandEmpty) {
                    var foolIndex = res.gambler.isRobot ? 1 : 0;

                    _this.setFool(_this.gamblers[foolIndex]);

                    break;
                  }
                }

                if (!res.gambler.isRobot) {
                  if (!_this.banker.isAttackerRobot) {
                    _this.queue.enqueue(new _DefendCommand["default"]({
                      store: _this
                    }));
                  } else {
                    _this.queue.enqueue(new _AttackCommand["default"]({
                      store: _this
                    }));
                  }
                }
              }

              _this.updateSilence(false);

              break;
            }

          case _constants.COMMANDS.ATTACK:
            {
              if (res.card) {
                _this.queue.enqueue(new _DiscardCardCommand["default"]({
                  store: _this,
                  card: res.card,
                  gambler: _this.gamblers[_constants.GAMBLERS.ROBOT]
                }));
              } else {
                _this.queue.enqueue(new _StartNewRoundCommand["default"]({
                  store: _this
                }));

                _this.queue.enqueue(new _DealCardsCommand["default"]({
                  store: _this,
                  gambler: _this.gamblers[_constants.GAMBLERS.ROBOT]
                }));

                _this.queue.enqueue(new _DealCardsCommand["default"]({
                  store: _this,
                  gambler: _this.gamblers[_constants.GAMBLERS.HUMAN]
                }));
              }

              break;
            }

          case _constants.COMMANDS.DEFEND:
            {
              if (res.card) {
                _this.queue.enqueue(new _DiscardCardCommand["default"]({
                  store: _this,
                  card: res.card,
                  gambler: _this.gamblers[_constants.GAMBLERS.ROBOT]
                }));
              } else {
                _this.queue.enqueue(new _TakeOpenedCardsCommand["default"]({
                  store: _this,
                  gambler: _this.gamblers[_constants.GAMBLERS.ROBOT]
                }));

                _this.queue.enqueue(new _DealCardsCommand["default"]({
                  store: _this,
                  gambler: _this.gamblers[_constants.GAMBLERS.ROBOT]
                }));

                _this.queue.enqueue(new _DealCardsCommand["default"]({
                  store: _this,
                  gambler: _this.gamblers[_constants.GAMBLERS.HUMAN]
                }));
              }

              break;
            }

          case _constants.COMMANDS.START_NEW_ROUND:
            {
              _this.banker.swapAttacker();

              _this.updateAttacker();

              _this.updateSilence(false);

              if (_this.banker.isAttackerRobot) {
                _this.queue.enqueue(new _AttackCommand["default"]({
                  store: _this
                }));
              }

              _this.updateSilence(false);

              break;
            }
        }
      }

      requestAnimationFrame(_this.run);
    });

    this.queue = new _CommandQueue["default"]();
    this.setData = setData;
    this.initBanker();
    this.initGamblers();
    this.initFirstCommands();
    requestAnimationFrame(function () {
      _this.run();
    });
  }

  _createClass(GameStore, [{
    key: "initBanker",
    value: function initBanker() {
      this.banker = new _Banker["default"]({
        store: this
      });
      this.updateCardLength();
      this.updateTrump();
    }
  }, {
    key: "initGamblers",
    value: function initGamblers() {
      this.gamblers = [new _Gambler["default"]({
        index: _constants.GAMBLERS.ROBOT
      }), new _Gambler["default"]({
        index: _constants.GAMBLERS.HUMAN
      })];
    }
  }, {
    key: "initFirstCommands",
    value: function initFirstCommands() {
      var _iterator = _createForOfIteratorHelper(this.gamblers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var gambler = _step.value;
          this.queue.enqueue(new _DealCardsCommand["default"]({
            store: this,
            gambler: gambler
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.queue.enqueue(new _SetFirstAttackerCommand["default"]({
        store: this
      }));
    }
  }, {
    key: "popCardFromDeck",
    value: function popCardFromDeck() {
      var card = this.deck.pop();

      if (!card) {
        this.updateCardLength();
      }

      return card;
    }
  }, {
    key: "layCard",
    value: function layCard(card) {
      this.queue.enqueue(new _DiscardCardCommand["default"]({
        store: this,
        card: card,
        gambler: this.gamblers[_constants.GAMBLERS.HUMAN]
      }));
    }
  }, {
    key: "takeCards",
    value: function takeCards() {
      this.queue.enqueue(new _TakeOpenedCardsCommand["default"]({
        store: this,
        gambler: this.gamblers[_constants.GAMBLERS.HUMAN]
      }));
      this.queue.enqueue(new _DealCardsCommand["default"]({
        store: this,
        gambler: this.gamblers[_constants.GAMBLERS.ROBOT]
      }));
      this.queue.enqueue(new _DealCardsCommand["default"]({
        store: this,
        gambler: this.gamblers[_constants.GAMBLERS.HUMAN]
      }));
      this.queue.enqueue(new _AttackCommand["default"]({
        store: this
      }));
    }
  }, {
    key: "hangUp",
    value: function hangUp() {
      this.queue.enqueue(new _StartNewRoundCommand["default"]({
        store: this
      }));
      this.queue.enqueue(new _DealCardsCommand["default"]({
        store: this,
        gambler: this.gamblers[_constants.GAMBLERS.ROBOT]
      }));
      this.queue.enqueue(new _DealCardsCommand["default"]({
        store: this,
        gambler: this.gamblers[_constants.GAMBLERS.HUMAN]
      }));
    }
  }, {
    key: "setFool",
    value: function setFool(gambler) {
      this.fool = gambler;
      this.updateFool();
    }
  }, {
    key: "updateSilence",
    value: function updateSilence(value) {
      this.setData(_constants.ACTIONS.SET_SILENCE, value);
    }
  }, {
    key: "updateTrump",
    value: function updateTrump() {
      this.setData(_constants.ACTIONS.SET_TRUMP, this.trump);
    }
  }, {
    key: "updateCardLength",
    value: function updateCardLength() {
      this.setData(_constants.ACTIONS.SET_DECK_LENGTH, this.deck.length);
    }
  }, {
    key: "updateAttacker",
    value: function updateAttacker() {
      this.setData(_constants.ACTIONS.SET_ATTACKER, this.banker.attacker);
    }
  }, {
    key: "updateGamblerHand",
    value: function updateGamblerHand(gambler) {
      var action = gambler.isRobot ? _constants.ACTIONS.SET_ROBOT_HAND : _constants.ACTIONS.SET_HUMAN_HAND;
      this.setData(action, _toConsumableArray(gambler.getHand()));
    }
  }, {
    key: "updateOpenedCards",
    value: function updateOpenedCards() {
      this.setData(_constants.ACTIONS.SET_OPENED_CARDS, _toConsumableArray(this.banker.openedCards));
    }
  }, {
    key: "updateFool",
    value: function updateFool() {
      this.setData(_constants.ACTIONS.SET_FOOL, this.fool);
    }
  }, {
    key: "deck",
    get: function get() {
      return this.banker.deck;
    }
  }, {
    key: "trump",
    get: function get() {
      return this.deck.trump;
    }
  }, {
    key: "openedCards",
    get: function get() {
      return this.banker.openedCards;
    }
  }]);

  return GameStore;
}();

exports["default"] = GameStore;